module.exports = __webpack_public_path__ + "img/minus_btn.fb51313c.png";